<template>
  <div>
  <sanad-tabs></sanad-tabs>
  <m-form
    :show-creation-data="false"
    :title="title"
    :showList="false"
    :listRoute="{ name: 'SanadsList' }"
    exportBaseUrl="reports/lists/sanads"
    :exportParams="{ id: this.id }"
    :canEdit="canEdit"
    :canDelete="false"
    :canSubmit="canSubmit"
    :isEditing.sync="isEditing"
    @goToForm="getItemByPosition"
    @submit="submit"
    @delete="deleteItem"
    @clearForm="clearForm()"
  >
    <template #header-btns>
      <v-tooltip top color="#019EF6">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="sanad-form-copy-btn"
            v-bind="attrs"
            v-on="on"
            @click="copySanadToNewSanad"
            class="export-btn mr-1 ml-1"
            rel="noopener noreferrer"
            icon
          >
            <v-img max-height="20" max-width="20" src="/img/icons/copy.svg"></v-img>
          </v-btn>
        </template>
        کپی سند به سند جدید
      </v-tooltip>
      <v-btn id="sanad-form-related" class="rounded-lg secondary white--text mr-3 ml-1"
             depressed v-if="relatedForm" :to="relatedForm.to">
        <v-icon class="ml-1">fa-external-link-square-alt</v-icon>
        {{ relatedForm.title }}
      </v-btn>
    </template>

    <template>
      <v-row style="margin-top: -20px">
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="4">
              <div id="sanad-form-local-id">
                <v-text-field class="rounded-lg" disabled label="عطف" v-model="item.local_id" background-color="white" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <!-- <v-text-field disabled label="شماره سند" v-model="item.code" ></v-text-field> -->
              <div id="sanad-form-code">
                <v-text-field
                  class="rounded-lg"
                  v-model="item.code"
                  label="شماره سند"
                  background-color="white"
                  @keyup.enter="getItemByCode(item.code)"
                >
                  <template #append>
                    <v-icon  class="mt-1" @click="getItemByCode(item.code)">fa-search</v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div id="sanad-form-date">
                <date
                  class="form-control"
                  v-model="item.date"
                  label=" * تاریخ سند"
                  :default="true"
                  :disabled="!isEditing"
                />
              </div>
            </v-col>
            <v-col cols="12" md="4" style="margin-top: -15px">
              <div id="sanad-form-type">
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  :disabled="!isEditing"
                  :items="sanadTypes"
                  v-model="item.type"
                  label="نوع سند"
                  :return-object="false"
                />
              </div>
            </v-col>
            <v-col cols="12" md="4" style="margin-top: -15px">
              <div id="sanad-form-is-auto-created">
                <v-select
                  class="rounded-lg"
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-if="item.created_by"
                  disabled
                  :items="[
                    { text: 'دستی', value: false },
                    { text: 'سیستمی', value: true },
                  ]"
                  v-model="item.is_auto_created"
                  label="نوع ثبت"
                />
              </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-center" style="margin-top: -15px">
              <div id="sanad-form-is-defined">
                <v-switch inset v-if="item.id" label="قطعی شده" v-model="item.is_defined" disabled />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="12">
              <div id="sanad-form-explanation">
                <v-textarea
                  class="rounded-lg"
                  label="شرح سند"
                  v-model="item.explanation"
                  :disabled="!isEditing"
                  height="85"
                ></v-textarea>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-row class="mb-1 mr-1 ml-1" style="margin-top: -15px">
          <v-col cols="12" md="3">
            <div id="sanad-form-created-by">
              <v-text-field
                class="rounded-lg"
                v-if="item.created_by"
                label="کاربر ایجاد کننده"
                disabled
                v-model="item.created_by.name"
              />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="sanad-form-created-at">
              <v-text-field
                class="rounded-lg"
                v-if="item.created_by"
                label="تاریخ و ساعت ایجاد"
                disabled
                v-model="item.created_at"
              />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="sanad-form-created-by-name">
              <v-text-field
                class="rounded-lg"
                v-if="item.created_by"
                label="آخرین ویرایش کننده"
                disabled
                v-model="item.created_by.name"
              />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="sanad-form-updated-at">
              <v-text-field
                class="rounded-lg"
                v-if="item.created_by"
                label="تاریخ و ساعت ویرایش"
                disabled
                v-model="item.updated_at"
              />
            </div>
          </v-col>
        </v-row>

        <v-col cols="12">
          <m-datatable
            :show-filter-row="true"
            :fixed_header="true"
            :height="inputTableHeight"
            :headers="headers"
            :items="rows"
            :showExportBtns="false"
            :showAppliedFilters="false"
            :showClearFiltersBtn="true"
            :showSelect="false"
            :filters.sync="filters"
          >
            <template #item.account.title="{ item }" v-tooltip="accountParentsName(item.account).join(' > ')">
              <account-select
                id="sanad-row-account"
                :horizontal="true"
                items-type="level3"
                v-model="item.account"
                :disabled="!isEditing"
                :floatAccount1.sync="item.floatAccount1"
                :floatAccount2.sync="item.floatAccount2"
                :floatAccount3.sync="item.floatAccount3"
                :floatAccount4.sync="item.floatAccount4"
              />
            </template>
            <template #item.explanation="{ item }">
              <row-textarea
                id="sanad-row-explanation"
                v-model="item.explanation"
                :disabled="!isEditing"
                :i="rows.indexOf(item)"
                @updateRowsExplanation="updateRowsExplanation"
                :truncate="false"
              />
            </template>
            <template style="width: 150px" #item.bed="{ item }">
              <money id="sanad-row-bed" :disabled="!isEditing || item.bes != 0" v-model="item.bed" />
            </template>
            <template #item.swap="{ item }" >
              <a id="sanad-row-swap" @click.prevent="exchangeValue(item)" href v-if="isEditing">
                <i class="fas fa-exchange-alt"></i>
              </a>
            </template>
            <template style="width: 150px" #item.bes="{ item }">
              <money  id="sanad-row-bes" :disabled="!isEditing || item.bed != 0" class="form-control" v-model="item.bes" />
            </template>
            <template #item.deleteRow="{ item }">
              <v-btn
                id="sanad-row-delete"
                @click="deleteRow(rows.indexOf(item))"
                class="red--text"
                icon
                :disabled="!isEditing || (rows.indexOf(item) == rows.length - 1)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <template #header.deleteRow="{ item }">
              <v-icon color="secondary" x-small>fa-trash</v-icon>
            </template>
            <template #body.append="{ headers }">
              <tr class="secondary white--text" key="last-row" style="position: sticky; bottom: 0">
                <td>
                  <v-btn  id="sanad-delete-all-row" class="rounded-lg error white--text"
                          depressed @click="deleteRow(-1)" :disabled="!isEditing">
                    حذف همه ردیف ها
                  </v-btn>
                </td>
                <td colspan="1" id="sanad-form-difference">
                  <span class="primary--text">اختلاف:</span>
                  <span v-if="bedSum != besSum">
                    {{ Math.abs(bedSum - besSum) | toMoney }}
                    {{ bedSum > besSum ? "بستانکار" : "بدهکار" }}</span
                  >
                </td>
                <td class="text-left primary--text">مجموع:</td>
                <td class>{{ bedSum | toMoney }}</td>
                <td class="d-print-none"></td>
                <td class>{{ besSum | toMoney }}</td>
                <td class="d-print-none"></td>
              </tr>
            </template>
          </m-datatable>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-dialog
          v-model="confirmDialog"
          class="rounded-lg"
          persistent
          @click:outside="confirmDialog = false"
          max-width="400"
        >
          <v-card class="rounded-lg pa-2">
            <v-card-title class="primary--text text-h5"> توجه!</v-card-title>
            <v-card-text class="pt-3 pr-7"> سند تراز نیست، میخواهید ادامه دهید؟</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" class="rounded-lg" depressed @click="confirmDialog = false"> خیر</v-btn>
              <v-btn depressed class="rounded-lg" color="success" @click="submitFromDialog"> بله</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="dialog" class="rounded-lg" persistent @click:outside="dialog = false" max-width="400">
          <v-card class="rounded-lg pa-2">
            <v-card-title class="primary--text text-h5"> توجه!</v-card-title>
            <v-card-text class="pt-3 pr-7"> از انجام این عملیات اطمینان دارید؟</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" class="rounded-lg" depressed @click="dialog = false"> خیر</v-btn>
              <v-btn depressed class="rounded-lg" color="success" @click="submitFromConfirmDialog"> بله</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </m-form>
  </div>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";

import { MFormMixin } from "@/components/m-form";
import SanadTabs from "@/views/panel/sanad/SanadTabs";

export default {
  name: "Form",
  components: {SanadTabs, money, date },
  mixins: [formsMixin, accountApiMixin, MFormMixin],
  props: ["id"],
  data() {
    return {
      confirmDialog: false,
      dialog: false,
      baseUrl: "sanads",
      permissionBasename: "sanad",
      appendSlash: true,
      hasList: false,
      hasIdProp: true,
      isDefinable: true,
      hasLock: true,
      rowKey: "account",
      filters: {},
      sanadTypes: [
        {
          text: "افتتاحیه",
          value: "o",
        },
        {
          text: "اختتامیه",
          value: "c",
        },
        {
          text: "عادی",
          value: "n",
        },
      ],
      headers: [
        {
          text: "* کد و نام حساب",
          value: "account.title",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "شرح ردیف",
          value: "explanation",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "بدهکار",
          value: "bed",
          align: "center",
          sortable: false,
          filterable: true,
          width: "150px",
        },
        {
          text: "",
          value: "swap",
          align: "center",
          sortable: false,
          filterable: false,
          width: "40px",
        },
        {
          text: "بستانکار",
          value: "bes",
          align: "center",
          sortable: false,
          filterable: true,
          width: "150px",
        },
        {
          text: "",
          value: "deleteRow",
          align: "center",
          sortable: false,
          filterable: false,
          width: "40px",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("سند حسابداری");
    },
    inputTableHeight() {
      let height = screen.height - 490;
      return height + "px";
    },
    relatedForm() {
      // not working for chequeStatusChange
      let forms = [
        {
          name: "factors.factor",
          title: "فاکتور",
          routeName: "FactorForm",
          params: { isPreFactor: false },
        },
        {
          name: "factors.factorsaggregatedsanad",
          title: "سند تجمیعی فاکتور",
          routeName: "FactorsAggregatedSanadForm",
        },
        {
          name: "factors.factor",
          types: ["ia", "oa"],
          title: "تعدیل",
          routeName: "AdjustmentForm",
        },
        {
          name: "factors.transfer",
          title: "انتقال",
          routeName: "TransferForm",
        },
        { name: "_dashtbashi.lading", title: "بارگیری", routeName: "Lading" },
        {
          name: "_dashtbashi.oilcompanylading",
          title: "بارگیری شرکت نفت",
          routeName: "OilCompanyLading",
        },
        {
          name: "cheques.statuschange",
          title: "چک",
          routeName: "ChequeDetail",
        },
        {
          name: "transactions.transaction",
          title: "دریافت/پرداخت",
          routeName: "TransactionForm",
        },
        {
          name: "imprests.imprestsettlement",
          title: "تسویه تنخواه",
          routeName: "ImprestSettlementForm",
        },
      ];
      let origin = this.item.origin;
      if (origin) {
        let form = forms.filter((o) => o.name == origin.name);
        if (form.length == 1) {
          form = form[0];
        } else {
          if (["ia", "oa"].includes(origin.type)) {
            form = {
              name: "factors.factor",
              types: ["ia", "oa"],
              title: "تعدیل",
              routeName: "AdjustmentForm",
            };
          } else {
            form = {
              name: "factors.factor",
              title: "فاکتور",
              routeName: "FactorForm",
              params: { isPreFactor: false },
            };
          }
        }

        let params = form.params ? form.params : {};
        console.log(form.name, form.title, form.routeName)
        return {
          title: this.item.origin.type_display || form.title,
          to: {
            name: form.routeName,
            params: {
              id: origin.id,
              type: origin.type,
              code: origin.code,
              ...params,
            },
          },
        };
      }
      return null;
    },
    canEdit() {
      if (!this.item.id) return true;
      return !this.item.is_auto_created;
    },
    bedSum() {
      let sum = 0;
      this.rows.forEach((r) => {
        if (r.bed) sum += +r.bed;
      });
      return sum;
    },
    besSum() {
      let sum = 0;
      this.rows.forEach((r) => {
        if (r.bes) sum += +r.bes;
      });
      return sum;
    },
  },
  methods: {
    submit(clearForm = true) {
      if (this.hasConfirmation) {
        this.dialog = true;
      } else if (this.bedSum != this.besSum) {
        this.confirmDialog = true;
      } else {
        if (this.item.id) this.updateItem(clearForm);
        else this.storeItem(clearForm);
      }
    },
    submitFromDialog(clearForm = false) {
      if (this.item.id) this.updateItem(clearForm);
      else this.storeItem(clearForm);
      this.confirmDialog = false;
    },
    submitFromConfirmDialog(clearForm = false) {
      if (this.bedSum != this.besSum) {
        this.confirmDialog = true;
      } else {
        if (this.item.id) this.updateItem(clearForm);
        else this.storeItem(clearForm);
      }
      this.dialog = false;
    },
    getItemTemplate() {
      return {
        type: "n",
      };
    },
    getRowTemplate() {
      return {
        bed: 0,
        bes: 0,
      };
    },
    getItemByCode(code) {
      this.log("Get sanad by code: ", code);
      return this.request({
        url: this.endpoint("sanads/byCode"),
        method: "get",
        params: {
          code,
        },
        success: (data) => {
          this.setItem(data);
        },
      });
    },
    setItem(item) {
      this.item = item;
      this.itemsToDelete = [];
      this.rows = [];
      item.items
        .sort((a, b) => a.order - b.order)
        .forEach((item) => {
          let row = { ...item };
          this.rows.push(row);
        });
      this.rows.push(this.getRowTemplate());
      this.changeRouteTo(item.id);
      this.isEditing = false;
    },
    copySanadToNewSanad() {
      let rows = this.copy(this.rows);
      this.clearForm();
      this.$nextTick(() => {
        this.rows = [];
        for (const row of rows) {
          if (row.id) delete row.id;
          this.rows.push({
            ...row,
          });
        }
      });
    },
    exchangeValue(row) {
      if (row) {
        let tmp = row.bed;
        row.bed = row.bes;
        row.bes = tmp;
      } else {
        for (const row of this.rows) {
          let tmp = row.bed;
          row.bed = row.bes;
          row.bes = tmp;
        }
      }
    },
    getSerialized() {
      let data = {
        item: this.extractIds(this.item),
        items: {
          ids_to_delete: this.itemsToDelete,
          items: [],
        },
      };

      this.rows.forEach((row, i) => {
        if (i == this.rows.length - 1) return;

        let item = this.copy(row);
        item = this.extractIds(item);
        item.bed = +item.bed;
        item.bes = +item.bes;

        data.items.items.push(item);
      });

      return data;
    },
  },
};
</script>

<style scoped lang="scss"></style>
